export const getSaleCategoryList = state => {
    return state.list
}

export const getSaleCategoryDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/saleCategory/getters.js